export default "__VITE_ASSET__Brg1byzS__"